<template>
    <v-container>
        <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <v-form
            ref="createGroupForm"
            v-model="createGroupFormValid"
            lazy-validation
        >
        <v-card class="mt-3 mb-4">
            <v-toolbar flat>
                <v-toolbar-title>
                <b>グループ情報</b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-spacer></v-spacer>
            <v-card-text class="px-3">
                <v-text-field
                    v-model="inputCreateGroup.name"
                    label="グループ名*"
                    required
                    :rules="nameRules"
                    outlined
                    clearable
                    dense
                ></v-text-field>
                <v-text-field
                    v-model="inputCreateGroup.email"
                    label="オーナーのメール*"
                    required
                    :rules="emailRules"
                    outlined
                    clearable
                    dense
                ></v-text-field>
                <v-autocomplete
                    v-model="inputCreateGroup.plants"
                    :disabled="isUpdating"
                    :items="allplants"
                    filled
                    chips
                    color="blue-grey lighten-2"
                    label="共有発電所"
                    item-text="name"
                    item-value="id"
                    multiple
                    :search-input.sync="search"
                    @change="search = ''"
                    no-data-text="該当データがありません。"
                >
                <template v-slot:selection="data">
                    <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                    >
                    {{ data.item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                    <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    </v-list-item-content>
                    </template>
                </template>
                </v-autocomplete>
            </v-card-text>
        </v-card>

        <v-card class="mt-3 mb-4">
            <v-data-table
                :headers="headersMember"
                :items="inputCreateGroup.members"
                class="elevation-1"
                hide-default-footer
                :items-per-page="-1"
                no-data-text="該当データがありません。"
            >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>
                    <b>メンバー</b>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="addMember" outlined color="primary"><v-icon left>mdi-account-multiple-plus</v-icon>メンバー追加</v-btn>
                </v-toolbar>
            </template>
                    
            <template v-slot:item.email="props">
                <v-text-field
                type="email"
                class="mt-4"
                v-model="props.item.email"
                outlined
                dense
                :rules="emailRules"
                ></v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn color="error" outlined @click="removeMember(item)">削除</v-btn>
            </template>
            </v-data-table>
        </v-card>
        </v-form>
        <v-spacer></v-spacer>
        <div class="text-right">
            <v-btn class="primary" @click="confirmSave" width=165>登録</v-btn>
        </div>
        <add-mail-dialog
            v-model="addMailDialog"
            :mails="inputCreateGroup.members"
        ></add-mail-dialog>
    </v-container>
</template>
<script>
import {store} from '@/store';
import AddMailDialog from '@/components/dialog/group/AddMailDialog.vue';
export default {
    name: "AddGroup",
    components: {
        'add-mail-dialog': AddMailDialog,
    },
    data() {
      return {
        createGroupFormValid: true,
        isUpdating: false,
        inputCreateGroup: {
            name: null,
            email: null,
            members: [],
            plants: [],
        },
        emailRules: [
            value => !!value || 'メルアドレスを入力してください.',
            value => value && value.length <= 50 || 'メールアドレスの長さは50文字以内にしてください。',
            value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || '有効なメールアドレスを入力してください。'
            }
        ],
        headersMember: [
          {
            align: 'left',
            text: 'メル',
            value: 'email',
            width: '70%',
          },
          {
            align: 'center',
            text: 'アクション',
            value: 'actions',
          }
        ],
        allplants: [],
        addMailDialog: false,
        breadcrumbs: [
            {
                text: "グループ",
                disabled: false,
                exact: true,
                to: "/group"
            },
            {
                text: "登録",
                disabled: false,
                exact: true,
                to: "",
            },
        ],
        nameRules: [
            value => (!!value && !!value.trim()) || 'グループ名を入力してください。',
            value => value && value.length <= 50 || 'グループ名の長さは50文字以内にしてください。',
        ],
        search: null,
      }
    },

    watch: {
        isUpdating (val) {
            if (val) {
                setTimeout(() => (this.isUpdating = false), 3000)
            }
        },
        select() {
            this.search = '';
        }
    },

    methods: {
        addMember() {
            this.addMailDialog = true;
        },
        removeMember(item) {
            const member_index =  this.inputCreateGroup.members.findIndex(x => x.id == item.id)
            this.inputCreateGroup.members.splice(member_index, 1);
        },
        getAllPlants() {
            this.allplants = [];
            this.axios.get("/api/group/all-plants/")
            .then((response) => {
                this.allplants = response.data;
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            })
        },
        remove(item) {
            const index = this.inputCreateGroup.plants.indexOf(item.id)
            if (index >= 0) this.inputCreateGroup.plants.splice(index, 1)
        },

        confirmSave() {
            if (this.$refs.createGroupForm.validate()) {
                const confirmDialog = {
                    title: '登録確認',
                    content: "新規なグループを登録します。よろしいですか。",
                    onAgree: () => this.save(),
                    onDisagree: null,
                };
                store.showConfirmDialog(confirmDialog);
            }
        },

        save() {
            if (this.$refs.createGroupForm.validate()) {
                store.showLoadingOverlay(true);
                this.axios.post("/api/group/create/", this.inputCreateGroup)
                .then((response) => {
                    this.$refs.createGroupForm.reset();
                    this.$emit("input");
                    store.showSuccessDialog("グループが作成されました。");
                    this.$router.push('/group/' + response.data.id);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        if ('existed_group' in error.response.data) {
                            store.showErrorDialog("このグループが存在されました。他の値で再度試してください。");
                        }
                    } 
                    else {
                        store.showErrorDialog("エラーが発生しました。再度試してください。");
                    }
                })
                .then(() => {
                    store.showLoadingOverlay(false);
                });
            }
        },
    },

    created() {
        this.getAllPlants();
    },
}
</script>
<style scoped>
</style>
